module.exports = __webpack_public_path__ + "Roboto-Medium.c54f2a3ee42d2a58d82f.ttf";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-Medium.ttf
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Medium.ttf
// module chunks = 16